import { render, staticRenderFns } from "./ClockIcon.vue?vue&type=template&id=6a4ea218&scoped=true&"
import script from "./ClockIcon.vue?vue&type=script&lang=ts&"
export * from "./ClockIcon.vue?vue&type=script&lang=ts&"
import style0 from "./ClockIcon.vue?vue&type=style&index=0&id=6a4ea218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4ea218",
  null
  
)

export default component.exports